import { defineMessages } from 'react-intl';

export const actionsMessages = defineMessages({
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
    lprDetection: {
        id: 'lpr-detection',
        defaultMessage: 'LPR Detection',
    },
    lprDetectionDescription: {
        id: 'lpr-detection-description',
        defaultMessage: 'Create a new LPR detection',
    },
    lpr: {
        id: 'lpr',
        defaultMessage: 'LPR',
    },
    lprSectionDescription: {
        id: 'lpr-section-description',
        defaultMessage: 'Actions for LPR cameras',
    },
    createLprDetection: {
        id: 'create-lpr-detection',
        defaultMessage: 'Create LPR detection',
    },
    point: {
        id: 'point',
        defaultMessage: 'Point',
    },
    identifierType: {
        id: 'identifier-type',
        defaultMessage: 'Identifier type',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    clickToUpload: {
        id: 'click-to-upload',
        defaultMessage: 'Click to upload',
    },
    images: {
        id: 'images',
        defaultMessage: 'Images',
    },
    createdLPRdetection: {
        id: 'created-lpr-detection',
        defaultMessage: 'LPR detection created',
    },
    createdLPRdetectionDescription: {
        id: 'created-lpr-detection-description',
        defaultMessage: 'LPR detection has been successfully created.',
    },
    selectDate: {
        id: 'select-date',
        defaultMessage: 'Select a date',
    },
    sendMessageToDisplay: {
        id: 'send-message-to-display',
        defaultMessage: 'Send a message to display',
    },
    displayMessage: {
        id: 'display-message',
        defaultMessage: 'Display message',
    },
    sendMessage: {
        id: 'send-message',
        defaultMessage: 'Send a message',
    },
    createdDisplayMessage: {
        id: 'created-display-message',
        defaultMessage: 'Display message created',
    },
    createdDisplayMessageDescription: {
        id: 'created-display-message-description',
        defaultMessage: 'Display message has been successfully created.',
    },
    action: {
        id: 'action',
        defaultMessage: 'Action',
    },
    idleState: {
        id: 'idle-state',
        defaultMessage: 'Idle state',
    },
    successfulEntrance: {
        id: 'successful-entrance',
        defaultMessage: 'Successful entrance',
    },
    rejectedEntrance: {
        id: 'rejected-entrance',
        defaultMessage: 'Rejected entrance',
    },
    successfulExit: {
        id: 'successful-exit',
        defaultMessage: 'Successful exit',
    },
    rejectedExit: {
        id: 'rejected-exit',
        defaultMessage: 'Rejected exit',
    },
    date: {
        id: 'date',
        defaultMessage: 'Date',
    },
    spaces: {
        id: 'spaces',
        defaultMessage: 'spaces',
    },
    ticket: {
        id: 'ticket',
        defaultMessage: 'Ticket',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    freeSpaces: {
        id: 'free-spaces',
        defaultMessage: 'Free spaces',
    },
    totalRemainingAmount: {
        id: 'total-remaining-amount',
        defaultMessage: 'Total remaining amount',
    },
    display: {
        id: 'display',
        defaultMessage: 'Display',
    },
    displaySectionDescription: {
        id: 'display-section-description',
        defaultMessage: 'Actions for displays',
    },
    displayModelNotSupportedError: {
        id: 'custom-error:component_display_model_not_supported',
        defaultMessage: 'The component is not a supported display device (missing or unknown display_model).',
    },
    displaySimulateRequestExecutionError: {
        id: 'custom-error:display_simulate_request_execution_error',
        defaultMessage: 'Failed to execute the request against the display server.',
    },
    exitPaymentDueAmount: {
        id: 'exit-payment-due-amount',
        defaultMessage: 'Exit payment — due amount',
    },
    exitPaymentInsertCard: {
        id: 'exit-payment-insert-card',
        defaultMessage: 'Exit payment — insert card',
    },
    exitPaymentCardAccepted: {
        id: 'exit-payment-card-accepted',
        defaultMessage: 'Exit payment — card accepted',
    },
    exitPaymentCardRejected: {
        id: 'exit-payment-card-rejected',
        defaultMessage: 'Exit payment — card rejected',
    },
    exitPaymentPinRequested: {
        id: 'exit-payment-pin-requested',
        defaultMessage: 'Exit payment — PIN requested',
    },
    exitPaymentProcessing: {
        id: 'exit-payment-processing',
        defaultMessage: 'Exit payment — processing',
    },
    exitPaymentConfirmed: {
        id: 'exit-payment-confirmed',
        defaultMessage: 'Exit payment — confirmed',
    },
    exitPaymentFailed: {
        id: 'exit-payment-failed',
        defaultMessage: 'Exit payment — failed',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    amountPaid: {
        id: 'amount-paid',
        defaultMessage: 'Amount paid',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
});
